import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';
import { LayoutSidebar } from '../../Layout';
import { SupportChatService } from '../support_chat/SupportChatService';

export function DataExplorerUpgradePage() {
    const { t } = useTranslation();

    const handleUpgradeClick = (e) => {
        e.preventDefault();
        const message = t('data_explorer.upgrade.intercom_message');
        SupportChatService.showNewMessage(message);
    };

    const benefits = [
        {
            icon: 'magnifying-glass-chart',
            title: t('data_explorer.upgrade.benefit_1_title'),
            desc: t('data_explorer.upgrade.benefit_1_desc'),
        },
        {
            icon: 'layer-group',
            title: t('data_explorer.upgrade.benefit_2_title'),
            desc: t('data_explorer.upgrade.benefit_2_desc'),
        },
        {
            icon: 'file-export',
            title: t('data_explorer.upgrade.benefit_3_title'),
            desc: t('data_explorer.upgrade.benefit_3_desc'),
        },
        {
            icon: 'chart-line',
            title: t('data_explorer.upgrade.benefit_4_title'),
            desc: t('data_explorer.upgrade.benefit_4_desc'),
        },
    ];

    return (
        <div className="app-content">
            <LayoutSidebar />
            <section className="section-content">
                <div className="upgrade-to-dashbo-page de-upgrade-page">
                    <div className="upgrade-hero">
                        <div className="upgrade-hero-badge">
                            <span className="icon"><FaIcon iconName="crown"/></span>
                            {t('data_explorer.upgrade.plan_badge')}
                        </div>
                        <div className="de-upgrade-main-icon">
                            <FaIcon iconName="binoculars"/>
                        </div>
                        <h1 className="upgrade-hero-title">{t('data_explorer.upgrade.title')}</h1>
                        <p className="upgrade-hero-subtitle">{t('data_explorer.upgrade.subtitle')}</p>
                        <button
                            type="button"
                            className="btn -alt upgrade-hero-cta"
                            onClick={handleUpgradeClick}
                        >
                            {t('data_explorer.upgrade.cta')}
                        </button>
                    </div>

                    <div className="upgrade-benefits">
                        <div className="benefits-grid">
                            {benefits.map((b, i) => (
                                <div key={i} className="benefit-card">
                                    <div className="benefit-card-icon">
                                        <span className="icon"><FaIcon iconName={b.icon}/></span>
                                    </div>
                                    <h3>{b.title}</h3>
                                    <p>{b.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="de-upgrade-footer">
                        <p className="de-upgrade-support">{t('data_explorer.upgrade.support')}</p>
                        <button
                            type="button"
                            className="btn -alt"
                            onClick={handleUpgradeClick}
                        >
                            {t('data_explorer.upgrade.cta')}
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}
